import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import Student from "../components/structureComponent/studentComponent";

export default function StudentPage() {
    return (
        <Layout>
            <Header/>
            <Student/>
            <Footer/>
        </Layout>
    );
};